import React, { useEffect, useState } from 'react';
import baseURL from '../../Components/url';
import './WhatsappForm.css';
export default function WhatsappForm(){
  const api = baseURL;
  const [titulo, setTitulo] = useState('Afíliate y sé parte de esta familia');
  const [empresa, setEmpresa] = useState('');
  const [nombre, setNombre] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [ok, setOk] = useState(false);
  const [primaryColor, setPrimaryColor] = useState('#0ea5e9');
  const [thanksMessage, setThanksMessage] = useState('¡Muchas gracias por afiliarte! Estamos felices de tenerte aquí.');
  const [visible, setVisible] = useState(true);
  useEffect(()=>{ 
    const loadCfg = ()=>{ fetch(`${api}/wppFormConfigGet.php`).then(r=>r.text()).then(t=>{ try{ const d=JSON.parse(t); if (d.titulo) setTitulo(String(d.titulo)); if (d.primaryColor) setPrimaryColor(String(d.primaryColor)); if (d.thanksMessage) setThanksMessage(String(d.thanksMessage)); if (typeof d.visible!=='undefined') setVisible(!!d.visible); }catch(_){ } }); };
    loadCfg();
    fetch(`${api}/tiendaGet.php`, { method:'GET' }).then(r=>r.text()).then(t=>{ try{ const d=JSON.parse(t); const tienda = (d?.tienda||[]).reverse()[0] || {}; setEmpresa(String(tienda?.nombre||'').trim()); }catch(_){ setEmpresa(''); } });
    const id = setInterval(loadCfg, 5000);
    return ()=> clearInterval(id);
  },[api]);
  const enviar = async (e)=>{
    e.preventDefault();
    const n = nombre.trim();
    const w = String(whatsapp||'').replace(/\D+/g,'');
    if (!n || !w) return;
    try{
      const r = await fetch(`${api}/wppAfiliadosPost.php`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ nombre:n, whatsapp:w }) });
      const t = await r.text(); let j; try{ j=JSON.parse(t);}catch(_){ j=null; }
      if (j && j.ok){ setOk(true); setNombre(''); setWhatsapp(''); }
    }catch(_){ }
  };
  if (!visible) return null;
  return (
    <section className='wpp-form-section'>
      <div className='wpp-form-card'>
        <div className='wpp-form-header' style={{ background: primaryColor }}>
          <h3 className='wpp-title'>{titulo}</h3>
          {empresa && <p className='wpp-subtitle'>{empresa}</p>}
        </div>
        {!ok ? (
          <form className='wpp-form' onSubmit={enviar}>
            <div className='wpp-field'>
              <label>Nombre</label>
              <input type='text' value={nombre} onChange={e=>setNombre(e.target.value)} placeholder='Tu nombre' required />
            </div>
            <div className='wpp-field'>
              <label>WhatsApp</label>
              <input type='tel' value={whatsapp} onChange={e=>setWhatsapp(e.target.value)} placeholder='Tu número de WhatsApp' required />
            </div>
            <button type='submit' className='wpp-btn'>Enviar</button>
          </form>
        ) : (
          <div className='wpp-modal'>
            <div className='wpp-modal-backdrop' onClick={()=>setOk(false)} />
            <div className='wpp-modal-content'>
              <h4 style={{ margin:'0 0 8px' }}>¡Gracias por afiliarte!</h4>
              <p style={{ margin:0 }}>{thanksMessage}</p>
              <div style={{ marginTop:12, display:'flex', justifyContent:'center' }}>
                <button className='wpp-btn' onClick={()=>setOk(false)} style={{ maxWidth:220 }}>Cerrar</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
